import { useIntl } from 'react-intl';
import { notification } from 'antd';
import { isObject } from 'lodash';

const checkIfIsFormError = (err) =>
  isObject(err) && 'values' in err && 'errorFields' in err;

const useDefaultFormErrorNotification = () => {
  const intl = useIntl();

  const sendFormErrorNotification = (err) => {
    if (!checkIfIsFormError(err)) {
      notification.error({
        message: intl.formatMessage({
          id: 'commons.form.notification.error',
        }),
        description: intl.formatMessage({
          id: 'commons.form.notification.errorDescription',
        }),
      });
    }
  };

  return { sendFormErrorNotification };
};

export default useDefaultFormErrorNotification;
